
export const getRegistry = async (id: string) => {
  const url = `${process.env.APP_API_SKYAIRLINE_BASE_URI}/registry-manager/v1/registry/${id}`;
  const headers = {
    homeMarket: "CL",
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": process.env.APP_SKYAIRLINE_SUSCRIPTION_KEY,
    pointOfSale: "CL",
  };

  try {
    const response = await fetch(url, { method: "GET", headers });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};
